import {useEffect, useState} from "react";
import AjaxService from "../platform/ajax/AjaxService";

/**
 * Loads an image from an authenticated (Bearer-protected) endpoint and returns an object URL usable
 * as an <img src>. A plain <img src="/api/..."> cannot be used for such endpoints because the browser
 * does not attach the Authorization header to image requests. Returns null while loading (or when the
 * url is null) and revokes the object URL on change/unmount.
 */
export function useAuthenticatedImage(url: string | null): string | null {
    const [objectUrl, setObjectUrl] = useState<string | null>(null);

    useEffect(() => {
        if (!url) {
            setObjectUrl(null);
            return;
        }

        let cancelled = false;
        let createdUrl: string | null = null;

        AjaxService.fetchAuthenticatedObjectUrl(url)
            .then(resultUrl => {
                if (cancelled) {
                    URL.revokeObjectURL(resultUrl);
                    return;
                }
                createdUrl = resultUrl;
                setObjectUrl(resultUrl);
            })
            .catch(error => console.error("Failed to load authenticated image " + url, error));

        return () => {
            cancelled = true;
            if (createdUrl) {
                URL.revokeObjectURL(createdUrl);
            }
        };
    }, [url]);

    return objectUrl;
}
